<template lang="pug">
  avue-crud(
    ref="crud",
    :data="data",
    :table-loading="loading",
    :option="option",
    :page.sync="page",
    @search-change="searchChange",
    @search-reset="searchReset",
    @current-change="currentChange",
    @size-change="sizeChange",
    @refresh-change="refreshChange",
    @on-load="onLoad"
  )
</template>
<script>
/**
 * 内容管理-公告管理-推送列表
 */
import { mapState } from 'vuex'
import { getPushedList } from '@/api/announce'
export default {
  name: 'PushedList',
  computed: {
    ...mapState('announce', ['currentRow'])
  },
  data() {
    return {
      form: {},
      data: [],
      query: {},
      loading: false,
      page: {
        pageSize: 20,
        currentPage: 1,
        total: 0
      },
      option: {
        indexLabel: '序号',
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        addBtn: false,
        editBtnText: '更新',
        searchShow: true,
        columnBtn: false,
        searchBtnText: '查询',
        emptyBtnText: '重置',
        stripe: true,
        searchSpan: 8,
        searchMenuSpan: 7,
        calcHeight: 350,
        tip: false,
        border: true,
        index: true,
        menu: false,
        column: [
          {
            label: '头像',
            prop: 'avatar',
            type: 'img',
            overHidden: true
          },
          {
            label: '昵称',
            prop: 'nickname',
            search: true,
            overHidden: true
          }, {
            label: '手机号',
            prop: 'mobile',
            search: true,
            overHidden: true
          }
        ]
      }
    }
  },
  watch: {
    'currentRow.id': function() {
      this.onLoad(this.page)
    }
  },
  methods: {
    searchReset() {
      this.query = {}
      this.onLoad(this.page)
    },
    searchChange(params, done) {
      this.query = params
      this.page.currentPage = 1
      this.onLoad(this.page, params)
      done()
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize
    },
    refreshChange() {
      this.onLoad(this.page, this.query)
    },
    onLoad(page, params = {}) {
      const { id } = this.currentRow
      const values = { ...params, announceId: id }
      this.loading = true
      getPushedList(page.currentPage, page.pageSize, values)
        .then((res) => {
          const data = res.data
          this.page.total = res.total
          this.data = data
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style>
.none-border {
  border: 0;
  background-color: transparent !important;
}
</style>
